export default {
  VIEWED: 'Credits Viewed',
  LEARN_MORE_PAGE_VIEWED: 'Credit Learn More Page Viewed',
  PURCHASE_PAGE_VIEWED: 'Credit Purchase Page Viewed',
  PURCHASE_ATTEMPTED: 'Credit Purchase Attempted',
  PURCHASE_COMPLETED: 'Credit Purchase Completed',
  PURCHASE_CANCELED: 'Credit Purchase Canceled',
};
